import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Box, Flex, Grid } from '../../../layout';
import { Heading } from '../../../typography';
import { IsVisible } from '../../../utils';
import { LinearLoader } from '../../../utils/loader/Linear';

interface ITableToolbarProps extends HTMLAttributes<HTMLDivElement> {
  centeredActions?: boolean;
  isLoading?: boolean;
  subheader?: React.ReactNode;
  title?: string;
  toolbarActions?: React.ReactNode;
}

export function TableToolbar({
  centeredActions = false,
  className,
  isLoading = false,
  subheader,
  title,
  toolbarActions,
  ...rest
}: ITableToolbarProps) {
  return (
    <div className={twMerge('', className)} {...rest}>
      <Grid
        className={classNames('items-center mb-8 lg:grid-cols-2', {
          'lg:grid-cols-[0.5fr_1.5fr]': centeredActions,
        })}
      >
        <Grid
          className={classNames('lg:grid-cols-2', {
            'lg:grid-cols-1': !subheader && centeredActions,
          })}
        >
          <IsVisible when={!!title}>
            <Box>
              <Heading className="text-gray-700 font-bold md:mr-6" variant="h3">
                {title}
              </Heading>
            </Box>
          </IsVisible>
          <IsVisible when={!!subheader}>
            <Box>{subheader}</Box>
          </IsVisible>
        </Grid>
        <Grid
          className={classNames('justify-end', {
            'justify-stretch': centeredActions,
          })}
        >
          <IsVisible when={!!toolbarActions}>{toolbarActions}</IsVisible>
        </Grid>
      </Grid>
      <Flex>
        <IsVisible when={isLoading}>
          <LinearLoader />
        </IsVisible>
      </Flex>
    </div>
  );
}
